// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-animation-0 {
  animation: slideUp 0.5s ease-out forwards;
  animation-delay: 0ms;
  opacity: 0;
}

.step-animation-1 {
  animation: slideUp 0.5s ease-out forwards;
  animation-delay: 200ms;
  opacity: 0;
}

.step-animation-2 {
  animation: slideUp 0.5s ease-out forwards;
  animation-delay: 400ms;
  opacity: 0;
}

.step-animation-3 {
  animation: slideUp 0.5s ease-out forwards;
  animation-delay: 600ms;
  opacity: 0;
}

.step-animation-4 {
  animation: slideUp 0.5s ease-out forwards;
  animation-delay: 800ms;
  opacity: 0;
}

@keyframes slideUp {
  0% {
    transform: translateY(30px) scale(0.95);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.animate-slideUp {
  opacity: 0;
  animation: slideUp 0.5s ease-out forwards;
}

.animate-fadeIn {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-section .step-animation-0 {
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: 200ms;
}

.animate-section .step-animation-1 {
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: 400ms;
}

.animate-section .step-animation-2 {
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: 600ms;
}

.animate-section .step-animation-3 {
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: 800ms;
}

.animate-section .step-animation-4 {
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: 1000ms;
}

.animate-section .step-animation-0,
.animate-section .step-animation-1,
.animate-section .step-animation-2,
.animate-section .step-animation-3,
.animate-section .step-animation-4 {
  will-change: transform, opacity;
  backface-visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Products/products.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;;;;;EAKE,+BAA+B;EAC/B,2BAA2B;AAC7B","sourcesContent":[".step-animation-0 {\n  animation: slideUp 0.5s ease-out forwards;\n  animation-delay: 0ms;\n  opacity: 0;\n}\n\n.step-animation-1 {\n  animation: slideUp 0.5s ease-out forwards;\n  animation-delay: 200ms;\n  opacity: 0;\n}\n\n.step-animation-2 {\n  animation: slideUp 0.5s ease-out forwards;\n  animation-delay: 400ms;\n  opacity: 0;\n}\n\n.step-animation-3 {\n  animation: slideUp 0.5s ease-out forwards;\n  animation-delay: 600ms;\n  opacity: 0;\n}\n\n.step-animation-4 {\n  animation: slideUp 0.5s ease-out forwards;\n  animation-delay: 800ms;\n  opacity: 0;\n}\n\n@keyframes slideUp {\n  0% {\n    transform: translateY(30px) scale(0.95);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.animate-slideUp {\n  opacity: 0;\n  animation: slideUp 0.5s ease-out forwards;\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-section .step-animation-0 {\n  animation: slideUp 0.6s ease-out forwards;\n  animation-delay: 200ms;\n}\n\n.animate-section .step-animation-1 {\n  animation: slideUp 0.6s ease-out forwards;\n  animation-delay: 400ms;\n}\n\n.animate-section .step-animation-2 {\n  animation: slideUp 0.6s ease-out forwards;\n  animation-delay: 600ms;\n}\n\n.animate-section .step-animation-3 {\n  animation: slideUp 0.6s ease-out forwards;\n  animation-delay: 800ms;\n}\n\n.animate-section .step-animation-4 {\n  animation: slideUp 0.6s ease-out forwards;\n  animation-delay: 1000ms;\n}\n\n.animate-section .step-animation-0,\n.animate-section .step-animation-1,\n.animate-section .step-animation-2,\n.animate-section .step-animation-3,\n.animate-section .step-animation-4 {\n  will-change: transform, opacity;\n  backface-visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
